import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { RecipientsApi } from '@shared/api/rest';
import { RecipientResponse } from '@shared/api/rest/recipients';

const effect = createEffect((id: string) => RecipientsApi.deleteRecipient(id));
const clearEvent = createEvent();

const $dataStore = createStore<RecipientResponse | null>(null)
  .on(effect.done, (current, values) => values.result.data || current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(effect.pending, (_, data) => data)
  .on(effect.fail, (_, data) => false)
  .on(effect.done, (_, data) => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(effect, () => null)
  .on(effect.fail, (_, data) => data.error.message)
  .on(effect.done, (_, data) => null)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

export const $deleteRecipientStore = {
  events: {
    delete: effect,
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
